import { render, staticRenderFns } from "./WM4.vue?vue&type=template&id=228992c7&scoped=true&"
import script from "./WM4.vue?vue&type=script&lang=js&"
export * from "./WM4.vue?vue&type=script&lang=js&"
import style0 from "./WM4.vue?vue&type=style&index=0&id=228992c7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228992c7",
  null
  
)

export default component.exports